import useBooleanToggle from "./useBooleanToggle";

interface DialogState {
  shown: boolean;
  show: () => void;
  hide: () => void;
  toggle: () => void;
  props: {
    open: boolean;
    onClose: () => void;
  };
}

export default function useDialogState(): DialogState {
  const [value, helpers] = useBooleanToggle();

  const props = {
    open: value,
    onClose: helpers.setFalse,
  };

  return {
    shown: value,
    show: helpers.setTrue,
    hide: helpers.setFalse,
    toggle: helpers.toggle,
    props,
  };
}
